module.exports = __webpack_public_path__ + "img/1-4.6256aa5e.svg";